import { useSEO } from '@/hooks/useSEO';
import Navbar from "./components/Navbar";
import AnnouncementBanners from "@/components/feature/AnnouncementBanners";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://isman.co.ke';

const HOME_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "ISMAN Engineering Company",
    "url": SITE_URL,
    "telephone": "+254724114555",
    "email": "info@isman.co.ke",
    "description": "ISMAN Engineering Company provides expert industrial engineering services including HVAC, commercial kitchen design, water treatment, food processing equipment and system automation in Nairobi, Kenya.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Nairobi",
      "addressRegion": "Nairobi County",
      "addressCountry": "KE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -1.2921,
      "longitude": 36.8219
    },
    "areaServed": { "@type": "Country", "name": "Kenya" },
    "sameAs": ["https://isman.co.ke"],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "17:00"
      }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "ISMAN Engineering Company",
    "url": SITE_URL
  }
];

export default function Home() {
  useSEO({
    title: 'ISMAN Engineering Company Nairobi Kenya | HVAC Kitchen Plumbing Welding',
    description: 'ISMAN Engineering Company provides expert HVAC, industrial machinery, commercial kitchen design, water treatment and plumbing services in Nairobi, Kenya. 15+ years, 500+ projects.',
    keywords: 'engineering services Nairobi, HVAC Kenya, commercial kitchen design Kenya, industrial machinery Kenya, water treatment Kenya, plumbing Kenya',
    canonical: SITE_URL,
    schema: HOME_SCHEMA,
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <AnnouncementBanners page="home" />
      <Hero />
      <Services />
      <About />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}
